module.exports = {
  "id": "19f27945-10de-4008-8d3b-3ac0211821a8",
  "gtmIds": [
    "GTM-MSJPDTKP",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "languages": [
    "en-US"
  ],
  "website": "https://www.jerseygirlkitchen.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}